import React, { Component, Fragment } from 'react'
import { Query } from 'react-apollo'

import Hero from '../../components/Hero/'
import Breadcrumb from '../../components/Breadcrumb/'
import Orders from '../../components/Orders/'
import Loader from '../../components/Loader'
import Error from '../../components/Error'

import withHeaderFooter from '../../wrapper/withHeaderFooter'

import { CATEGORIES_QUERY, ORDER_QUERY, SELF_QUERY, PORTAL_ORDER_QUERY, PRODUCTS_QUERY } from '../../queries'
import { OCI } from '../../constants'

import { Container } from '../../styles/defaults'
import { StatusBar } from './styles'

import helpers from '../../helpers'

import hero from '../../assets/hero/bestellijst/bestellijst.jpg'

class OrderList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      statusText: ''
    }
  }
  

  componentDidMount() {
    const ociPlatform = window.sessionStorage.getItem(OCI)
    const { portalOrder, servicePackage, nextDeliveryDate, branch, delivery } = this.props
    this.setState({statusText: helpers.getStatusText(portalOrder, servicePackage, nextDeliveryDate, branch.suspended, delivery, ociPlatform)})
  }

  render() {
    const ociPlatform = window.sessionStorage.getItem(OCI)
    return (
      <Fragment>
        <Hero setsize="small" small={hero} medium={hero} large={hero} retina={hero} title="Bestellijsten" />
        <Breadcrumb title="Bestellijsten" />
        {this.state.statusText !== '' ? (
          <Container mt>
            <StatusBar dangerouslySetInnerHTML={{__html: this.state.statusText}} />
          </Container>
        ) : null}
        <Query query={SELF_QUERY}>
          {({ loading, error, data }) => {
            if (loading) return <Loader from="25%" to="45%" fixed />
            if (error) return <Error error="de gebruikersgegevens" />
            const { self } = data
            let viewOrders = self.permissions.includes('VIEW_ORDERS') || self.role === 'MANAGER'
            let editOrder = self.permissions.includes('EDIT_ORDER') || self.role === 'MANAGER'
            let sendOrder = self.permissions.includes('SEND_ORDER') || self.role === 'MANAGER'
            let createOrder = self.permissions.includes('EDIT_ORDER') || self.role === 'MANAGER'
            let viewPrices = self.permissions.includes('VIEW_PRICES') || self.role === 'MANAGER'
            let createNewOrder = createOrder

            if (viewOrders && !this.props.branch.suspended) {
              return (
                <Query query={CATEGORIES_QUERY}>
                  {({ loading, error, data }) => {
                    if (loading) return <Loader from="45%" to="75%" fixed />
                    if (error) return <Error error="de producten" />
                    const { categories } = data
                    const strippedProducts = helpers.strippedProducts(categories)

                    if (!this.props.orderId) {
                      return (
                        <Container mt mb>
                          Er zijn momenteel geen bestellingen beschikbaar.
                        </Container>
                      )
                    }
                    
                    return (
                      <Query query={ORDER_QUERY} variables={{ id: this.props.orderId }}>
                        {({ loading, error, data }) => {
                          if (loading) return <Loader from="75%" to="100%" fixed />
                          if (error || !data.order) return <Error error="uw bestellijst" />
                          let defaultOrder = data.order

                          return (
                            <Query query={this.props.portalOrderId ? PORTAL_ORDER_QUERY : ORDER_QUERY} variables={{ id: this.props.portalOrderId ? this.props.portalOrderId : this.props.orderId }}>
                              {({ loading, error, data }) => {
                                if (loading) return <Loader from="75%" to="100%" fixed />
                                if (error) return <Error error="uw bestellijst" />
                                let type = this.props.portalOrderId ? 'portalOrder' : 'order'
                                let order = {}
                                let emptyOrder = {
                                  orderParts: []
                                }
                                const orderData = data[type]

                                if (this.props.portalOrderId && (data[type].code === '30' || data[type].code === '35')) {
                                  // Find all products that are available in the default order but not in the portalOrder
                                  defaultOrder.orderParts.map(defaultOrderPart => {
                                    let notFound = data[type].orderParts.filter((orderPart) => defaultOrderPart.product.productCode === orderPart.product.productCode).length === 0
                                    if (notFound) {
                                      emptyOrder.orderParts.push(defaultOrderPart)
                                    }
                                    return null
                                  })
                                }
      
                                data[type].orderParts.map(orderPart => {
                                  order[orderPart.id] = orderPart.product.category.category === 'SUP' ? 0 : orderPart.amount
                                  return null
                                })

                                let { orderId } = this.props
                                const oldOrderId = orderId
                                orderId = this.props.portalOrderId ? this.props.portalOrderId : orderId
                                const { servicePackage } = data[type].branch
                                if (servicePackage === 'Ondersteun') {
                                  sendOrder = this.props.portalOrderId && (data[type].code !== '40' && data[type].code !== '25') ? sendOrder : false
                                  editOrder = this.props.portalOrderId && (data[type].code !== '40' && data[type].code !== '25') ? editOrder : false
                                  createOrder = false
                                  createNewOrder = false
                                } else {
                                  editOrder = servicePackage === 'Flexibel' && this.props.portalOrderId && (data[type].code !== '40' && data[type].code !== '25') ? editOrder : false
                                  sendOrder = servicePackage === 'Flexibel' && this.props.portalOrderId && (data[type].code !== '40' && data[type].code !== '25') ? sendOrder : false
                                  createOrder = servicePackage === 'Flexibel' && !this.props.portalOrderId &&  (data[type].code !== '40' && data[type].code !== '25') ? createOrder : false
                                  createNewOrder = servicePackage === 'Flexibel' && data[type].code === '40' ? createNewOrder : false
                                }

                                let deleteOciOrder = false

                                if (data[type].submitted && ociPlatform) {
                                  sendOrder = false
                                  editOrder = false
                                  createOrder = false
                                  createNewOrder = false
                                  deleteOciOrder = true
                                }

                                return (
                                  <Query query={PRODUCTS_QUERY}>
                                    {({ loading, error, data }) => {
                                      if (loading) return <Loader from="75%" to="100%" fixed />
                                      if (error) return <Error error="uw bestellijst" />
                
                                      return (
                                        <Orders
                                          order={order}
                                          emptyOrder={emptyOrder}
                                          products={this.props.products}
                                          wholeOrder={orderData}
                                          priceAgreements={this.props.branch.priceAgreements}
                                          viewPrices={viewPrices}
                                          strippedProducts={strippedProducts}
                                          orderId={orderId}
                                          oldOrderId={oldOrderId}
                                          editOrder={editOrder}
                                          sendOrder={sendOrder}
                                          createOrder={createOrder}
                                          createNewOrder={createNewOrder}
                                          deleteOciOrder={deleteOciOrder}
                                          servicePackage={servicePackage}
                                          user={self}
                                          branchData={this.props.branch}
                                          branch={this.props.branchId}
                                          branchName={this.props.branchName}
                                          portalOrderId={this.props.portalOrderId}
                                          productData={data.products}
                                          ociPlatform={ociPlatform}
                                        />
                                      )
                                    }}
                                  </Query>
                                )
                              }}
                            </Query>
                          )
                        }}
                      </Query>
                    )
                  }}
                </Query>
              )
            } else {
              return (
                <Container mt mb>
                  Onvoldoende rechten om de bestellingen te bekijken
                </Container>
              )
            }
          }}
        </Query>
      </Fragment>
    )
  }
}

export default withHeaderFooter(OrderList)



// WEBPACK FOOTER //
// ./src/views/OrderList/index.js